import { useIntl } from '@doxyme/locale';
import { Icon } from '@doxyme/icons';
import { useTheme } from '@doxyme/ui-foundation/theme';
import { BodyS, LinkS } from '@doxyme/ui-foundation/typography';
import { AppLink } from '../../../global/appLink';
import { getPublicRuntimeConfig } from '../../../../libs/init/getPublicRuntimeConfig';
import { useBrandedVirtualBackgroundPlaceholderStyles } from './brandedVirtualBackgroundPlaceholder.styles';

export const BrandedVirtualBackgroundPlaceholder = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { paths } = getPublicRuntimeConfig();

  const styles = useBrandedVirtualBackgroundPlaceholderStyles(theme);

  return (
    <div css={styles.container}>
      <div css={styles.content}>
        <BodyS tag='p' fontWeight='medium' color={theme.text.generic.primary}>
          {formatMessage({ id: 'virtualBackground.branded.empty.message' })}
        </BodyS>
        <AppLink href={paths.customBranding}>
          <span
            css={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: theme.spacing(2),
            }}
          >
            <LinkS fontWeight='medium' color={theme.text.link.default}>
              {formatMessage({
                id: 'virtualBackground.branded.empty.goToSettings',
              })}
            </LinkS>
            <Icon.Open
              size='xsmall'
              color={theme.text.link.default}
              aria-hidden
            />
          </span>
        </AppLink>
      </div>
    </div>
  );
};
